import * as React from 'react'
import '../../styles/pages.css'
import { PaginatedResourceList } from './resourceList/PaginatedResourceList'
import { useCallback, useMemo } from 'react'
import { Column } from 'shared/ui/Table/types'
import { SortableHeader } from '../utility/SortableHeader'
import { List } from 'infrastructure/api'
import { useNavigateTo } from 'infrastructure/routing'
import { useResourceRoutes } from 'shared/api/resourceRouting'
import { Box, Button } from '@mui/material'
import { StringFilter } from './resourceList/StringFilter'
import { VerifiedSelect } from './resourceList/SelectFilter'
import { Add } from '@mui/icons-material'
import { SwitchFilter } from './resourceList/SwitchFilter'
import { deleteSchool } from 'shared/api/mutations'

export function SchoolList() {
  const columns = useSchoolColumns()
  const onBulkDelete = useCallback((ids: (number | string)[]) => {
    return deleteSchool(ids as number[], true)
  }, [])
  return (
    <PaginatedResourceList
      title={'Schools'}
      resourceKey={'schools'}
      columns={columns}
      header={<SchoolFilters />}
      onBulkDelete={onBulkDelete}
    />
  )
}

function SchoolFilters() {
  const navigate = useNavigateTo()
  const { create } = useResourceRoutes('schools')
  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        <StringFilter filterKey={'schoolSearch'} label={'School Name / ID'} />
        <StringFilter
          filterKey={'districtSearch'}
          label={'District Name / ID'}
        />
        <VerifiedSelect />
        <SwitchFilter
          label="Include Soft Deleted"
          filterKey="includeSoftDeleted"
        />
      </Box>
      <Box>
        <Button
          variant="text"
          startIcon={<Add />}
          onClick={() => navigate(create)}
        >
          Create
        </Button>
      </Box>
    </Box>
  )
}

function useSchoolColumns(): Column<List.School>[] {
  return useMemo(
    () => [
      {
        title: <SortableHeader title={'School Id'} id={'id'} />,
        width: 175,
        rowContent({ id }: List.School) {
          return id
        },
      },
      {
        title: <SortableHeader title={'School Name'} id={'name'} />,
        width: 400,
        rowContent({ name }: List.School) {
          return name
        },
      },
      {
        title: <SortableHeader title={'District Id'} id={'district.id'} />,
        width: 175,
        rowContent({ district }: List.School) {
          return district?.id
        },
      },
      {
        title: <SortableHeader title={'District Name'} id={'district.name'} />,
        width: 400,
        rowContent({ district }: List.School) {
          return district?.name
        },
      },
      {
        title: 'Is Verified',
        width: 100,
        rowContent({ is_verified }: List.School) {
          return is_verified ? '✓' : 'X'
        },
      },
      {
        title: 'Kiddom Access',
        width: 100,
        rowContent(school: List.School) {
          let status = (
            <span style={{ color: 'green', textAlign: 'center' }}>Enabled</span>
          )
          if (school.deleted_at !== null) {
            status = (
              <span style={{ color: 'red', textAlign: 'center' }}>Deleted</span>
            )
          }
          return status
        },
      },
    ],
    [],
  )
}
